// Procedural world, FX and icon art (owner: art-world-fx). Called once by BootScene.
// Every builder skips texture keys that already exist, so AI-generated files listed
// in public/assets/manifest.json always override these fallbacks.

import type Phaser from 'phaser';
import { buildFxBase } from './fx';
import { buildIcons } from './icons';
import { buildParallax } from './parallax';
import { buildOrbs, buildProps } from './props';
import { buildTilesets } from './tiles';

export { FX_EXTRA } from './fx';
export { EXIT_COLOR } from './props';

/** FX + projectile textures (TEX generic/projectile keys). */
export function buildFxArt(scene: Phaser.Scene): void {
  buildFxBase(scene);
}

/** Tilesets, props, orbs, pickups, procedural parallax fallback layers. */
export function buildWorldArt(scene: Phaser.Scene): void {
  buildTilesets(scene);
  buildProps(scene);
  buildOrbs(scene);
  buildParallax(scene);
}

/** Interface icons (iconKey.*). */
export function buildIconArt(scene: Phaser.Scene): void {
  buildIcons(scene);
}
